import { render, staticRenderFns } from "./wxDialog.vue?vue&type=template&id=3b8b0936&"
import script from "./wxDialog.vue?vue&type=script&lang=js&"
export * from "./wxDialog.vue?vue&type=script&lang=js&"
import style0 from "./wxDialog.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports